module.exports = __webpack_public_path__ + "img/MEDIA113.a44fbe45.jpg";